import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { getUserById } from "~/store/selectors/selector.users";

export const RequireActiveUserAccess = ({ children }) => {
  const { userId } = useParams();
  const user = useSelector((state) => getUserById(state, +userId));

  return user && !user?.is_archived ? children : <Navigate to={`/users/${userId}/activity`} />;
};

RequireActiveUserAccess.propTypes = {
  children: PropTypes.any,
};
